import React from 'react';
import { HeaderGroup } from 'react-table';
import HeaderCell from './HeaderCell';

interface Props<D extends object> {
    headerGroups: HeaderGroup<D>[];
    dataTestId: string;
    isExecutionOrderSelectOption?: boolean;
}

const THead = <D extends object = {}>({ headerGroups, dataTestId, isExecutionOrderSelectOption }: Props<D>) => {
    return (
        <div className='thead' role='rowgroup' data-testid={`${dataTestId}-thead`}>
            {headerGroups.map((headerGroup) => {
                const { key: trKey, ...headerGroupProps } = headerGroup.getHeaderGroupProps();
                return (
                    <div className='tr' key={trKey} {...headerGroupProps} data-testid={`${dataTestId}-tr`}>
                        {headerGroup.headers.map((column) => {
                            return (
                                <HeaderCell
                                    key={column.id}
                                    column={column}
                                    isExecutionOrderSelectOption={isExecutionOrderSelectOption}
                                />
                            );
                        })}
                    </div>
                );
            })}
        </div>
    );
};

export default THead;
